module.exports = __webpack_public_path__ + "img/image (17).79d2a325.webp";